module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/terms-of-use/terms-of-use-page/terms-of-use-page.component.css
// module id = ./src/app/components/terms-of-use/terms-of-use-page/terms-of-use-page.component.css
// module chunks = main